// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"0deb279e0a74ab389745","293":"d4e7a711a3c2c7221ffc"}[chunkId] + ".js";
};